<template>
    <div class="DashboardItem" v-once @click="click($event.target)">
        <div class="DashboardItem__icon">
            <i :class="[icon]"></i>
        </div>
        <div class="DashboardItem__header">{{translate(name)}}</div>
        <div class="DashboardItem__icon-right">
            <i class="icon-angle-right"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DashboardItem',
        props: {
            //Item name 
            name: {
                type: String,
                required: true
            },
            //Icon class
            icon: {
                type: String,
                required: true
            }
        },
        methods: {
            click: function (e) {
                this.$emit('click', e);
            }
        }
    };
</script>

<style>
    .DashboardItem {
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        color: #fff;
        background: #607D8B;
        border-bottom: 1px solid #546E7A;
    }

    .DashboardItem__icon {
        padding-left: 8px;
        font-size: 30px;
        color: rgba(255, 255, 255, 0.3);
    }

    .DashboardItem__icon-right {
        display: none;
    }

    @media (max-width: 600px) {
        .DashboardItem {
            width: 100%;
        }

        .DashboardItem__icon-right {
            display: block;
            font-size: 24px;
        }
    }

    @media (max-width: 960px) and (min-width: 600px) {
        .DashboardItem {
            width: 45%;
            margin: 12px 6px 0 6px;
            color: #000000;
            background: rgba(255, 255, 255, 0.4);
            border: 1px solid rgba(255,255,255,0.2);
            border-radius: 2px;
            box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        }

        .DashboardItem__icon {
            color: rgba(69, 90, 100, 0.3);
        }
    }

    @media (min-width: 960px) {
        .DashboardItem {
            width: 30%;
            margin: 16px 8px 0 8px;
            color: #000000;
            background: rgba(255, 255, 255, 0.4);
            border: 1px solid rgba(255,255,255,0.2);
            border-radius: 2px;
            box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        }

        .DashboardItem__icon {
            color: rgba(69, 90, 100, 0.3);
        }
    }

    .DashboardItem__header {
        padding: 16px 8px;
        font-size: 18px;
        font-weight: 500;
        letter-spacing: normal;
        line-height: 2rem;
        margin: 0;
        flex: 1 1 auto;
    }

</style>



// WEBPACK FOOTER //
// DashboardItem.vue?2d910182